import { put, call } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import {
    getModuleSuccess, getModuleFail,
    getAllModulesSuccess, getAllModulesFail,
    getModulesByStatusSuccess, getModulesByStatusFail,
    getRootModulesSuccess, getRootModulesFail,
    getChildModulesSuccess, getChildModulesFail,
    createModuleSuccess, createModuleFail,
    updateModuleSuccess, updateModuleFail,
    deleteModuleSuccess, deleteModuleFail,
    setModuleLoading,
} from '../actions/moduleActions';
import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from '../../../api';

const buildModulePayload = (payload = {}) => {
    const imageFile = payload.imageFile || null;
    const clean = { ...payload };
    delete clean.imageFile;

    if (!imageFile) {
        return clean;
    }

    const formData = new FormData();
    formData.append('payload', JSON.stringify(clean));
    formData.append('image', imageFile);
    return formData;
};

// GET /api/modules/{id}
export function* getModuleSaga(action) {
    const url = `${API_BASE_URL}/api/modules/${action.payload.moduleId}`;
    yield put(setModuleLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getModuleSuccess(resp.data));
    } catch (error) {
        yield put(getModuleFail(error.message));
    } finally {
        yield put(setModuleLoading(false));
    }
}

// GET /api/modules
export function* getAllModulesSaga() {
    const url = `${API_BASE_URL}/api/modules`;
    yield put(setModuleLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getAllModulesSuccess(resp.data));
    } catch (error) {
        yield put(getAllModulesFail(error.message));
    } finally {
        yield put(setModuleLoading(false));
    }
}

// GET /api/modules/status/{status}
export function* getModulesByStatusSaga(action) {
    const url = `${API_BASE_URL}/api/modules/status/${action.payload.status}`;
    yield put(setModuleLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getModulesByStatusSuccess(resp.data));
    } catch (error) {
        yield put(getModulesByStatusFail(error.message));
    } finally {
        yield put(setModuleLoading(false));
    }
}

// GET /api/modules/root
export function* getRootModulesSaga() {
    const url = `${API_BASE_URL}/api/modules/root`;
    yield put(setModuleLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getRootModulesSuccess(resp.data));
    } catch (error) {
        yield put(getRootModulesFail(error.message));
    } finally {
        yield put(setModuleLoading(false));
    }
}

// GET /api/modules/parent/{parentId}
export function* getChildModulesSaga(action) {
    const url = `${API_BASE_URL}/api/modules/parent/${action.payload.parentId}`;
    yield put(setModuleLoading(true));
    try {
        const resp = yield call(getRequest, { url });
        yield put(getChildModulesSuccess(resp.data));
    } catch (error) {
        yield put(getChildModulesFail(error.message));
    } finally {
        yield put(setModuleLoading(false));
    }
}

// POST /api/modules
export function* createModuleSaga(action) {
    const url = `${API_BASE_URL}/api/modules`;
    const data = buildModulePayload(action.payload);
    yield put(setModuleLoading(true));
    try {
        const resp = yield call(postRequest, { url, data });
        yield put(createModuleSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Module créé avec succès',
            timer: 2000,
            showConfirmButton: false,
        });
    } catch (error) {
        yield put(createModuleFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: 'Erreur lors de la création',
            timer: 2000,
            showConfirmButton: false,
        });
    } finally {
        yield put(setModuleLoading(false));
    }
}

// PUT /api/modules/{id}
export function* updateModuleSaga(action) {
    const url = `${API_BASE_URL}/api/modules/${action.payload.moduleId}`;
    const data = buildModulePayload(action.payload.moduleData);
    yield put(setModuleLoading(true));
    try {
        const resp = yield call(putRequest, { url, data });
        yield put(updateModuleSuccess(resp.data));
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: '',
            text: 'Module mis à jour avec succès',
            timer: 2000,
            showConfirmButton: false,
        });
    } catch (error) {
        yield put(updateModuleFail(error.message));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: '',
            text: 'Erreur lors de la mise à jour',
            timer: 2000,
            showConfirmButton: false,
        });
    } finally {
        yield put(setModuleLoading(false));
    }
}

// DELETE /api/modules/{id}
export function* deleteModuleSaga(action) {
    const url = `${API_BASE_URL}/api/modules/${action.payload.moduleId}`;
    yield put(setModuleLoading(true));
    try {
        yield call(deleteRequest, { url });
        yield put(deleteModuleSuccess(action.payload.moduleId));
        yield call([Swal, Swal.fire], {
            icon: 'success',
            title: 'Succès',
            text: 'Module supprimé avec succès',
            timer: 2000,
            showConfirmButton: false,
        });
    } catch (error) {
        let errorMessage = 'Erreur lors de la suppression';
        if (error.response && error.response.status === 409) {
            errorMessage =
                (error.response.data && error.response.data.message) ||
                'Ce module est utilisé ailleurs';
        } else if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message;
        } else if (error.message) {
            errorMessage = error.message;
        }
        yield put(deleteModuleFail(errorMessage));
        yield call([Swal, Swal.fire], {
            icon: 'error',
            title: 'Suppression impossible',
            text: errorMessage,
            confirmButtonText: 'OK',
            confirmButtonColor: '#d33',
        });
    } finally {
        yield put(setModuleLoading(false));
    }
}
